<template>
<div class="card-item"
  :id="item.itemId + '-' + itemIndex">
  <div class="card-item-heading">
    <Input type="text"
      placeholder="見出しを入力"
      v-model="item.heading"></Input>
  </div>
  <div class="card-item-content">
    <Input type="textarea"
      :autosize="{minRows: item.data.minRaws || 2,maxRows: 10}"
      placeholder=""
      v-model="item.data.text" />
  </div>
  <div class="card-footer">
    <div class="delete-item">
      <Button @click="destroyMe"
        shape="circle"
        icon="ios-trash-outline"></Button>
    </div>
  </div>
</div>
</template>

<script>
export default {
  data() {
    return {}
  },
  props: ['item', 'groupIndex', 'itemIndex'],
  computed: {},
  mounted: function () {},
  methods: {
    destroyMe: function () {
      this.$eventHub.$emit('destroyCustomCard', this.groupIndex, this.itemIndex)
    }
  }
}
</script>
